export const adminRoutes = {
  root: 'admin',
  clients: 'clients',
  entityTypes: 'entity-types',
  securityTypes: 'security-types',
  residencyJurisdictions: 'residency-jurisdictions',
  investmentJurisdictions: 'investment-jurisdictions',
  rulesManager: 'rules-manager',
  ruleEditor: 'rule-editor',
  generalRatesRuleEngine: 'general-rates-rule-engine',
  taxResult: {
    root: 'tax-results',
    details: 'details',
  },
  users: {
    root: 'users',
    internalUsers: 'internal',
    externalUsers: 'external',
  },
  exportTaxRateValues: '',
};
